var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9 46.359c0 .686-16.654 1.241-35.017 1.241C14.52 47.6 1.4 47.045 1.4 46.359s13.12-1.24 31.483-1.24 35.017.555 35.017 1.24z",
    fill: "#221F1F",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57585A",
    fillRule: "nonzero",
    d: "m60.991 44.24-54.334-.057.7-10.32 53.634.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.985 36.896s-.1-2.703 0-4.26c.098-1.555 10.765-8.257 15.893-9.52 5.127-1.265 16.886-.599 19.993.06 1.03.218 2.453.573 3.007.88.757.418 4.993 4.25 9.946 6.617.141.067.284.128.431.183.287.108.595.137.916.19 1.57.26 5.604.496 10.846 2.705 3.18 1.34 3.097 6.442 2.934 8.57-.046.605-.31.844-.31.844-.581.662-3.79 1.061-7.648 1.153a5.595 5.595 0 0 0 .778-2.84c0-3.116-2.56-5.641-5.72-5.641-3.157 0-5.72 2.525-5.72 5.64a5.549 5.549 0 0 0 .763 2.81c-2.792.014-18.344.092-30.702.086a5.583 5.583 0 0 0 .812-2.896c0-3.115-2.56-5.64-5.72-5.64-3.16 0-5.72 2.525-5.72 5.64 0 .52.073 1.022.206 1.5.135.478.33.932.581 1.353a28.79 28.79 0 0 1-1.425-.042c-1.856-.166-3.955-.036-4.785-2.107-.14-.35-.232-.77-.26-1.276-.162-2.915.904-4.009.904-4.009z",
    fill: "#F2AE18",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1 37.022s-2.86.291-3.993-.535c-1.134-.827-2.415-2.357-2.415-2.357s2.907-.551 4.733.606c1.824 1.16 1.676 2.287 1.676 2.287l-.001-.001zM2.97 32.83s4.73-.218 4.609.801c-.03.255-1.567 2.055-2.537 2.392-.998.35-1.925.38-2.073.38-.07 0 .002-3.573.002-3.573H2.97zM2.111 39.79c.124-.011 1.148-.129 1.554.07.34.166.36.823-.425.86-.92.044-1.175 0-1.175 0s-.008-.794.048-.93H2.11z",
    fill: "#EDEDED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.479 39.836s-2.116.02-2.645.139c-.469.105-1.04.832-1.1 1.625-.057.787 3.143.397 3.722.369.13-.889.023-2.133.023-2.133z",
    fill: "#393939",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.485 35.838c3.16 0 5.72 2.526 5.72 5.64 0 .557-.082 1.095-.235 1.602l-2.377.01s-5.154-.075-8.622-.113a5.598 5.598 0 0 1-.205-1.5c0-3.115 2.56-5.64 5.719-5.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.995 44.32c.251-.427.449-.89.581-1.378 3.918-.072 6.216-.395 7.375-.62-.046.606-.31.845-.31.845-.581.66-3.79 1.06-7.648 1.152h.002zM7.971 42.977c.135.478.33.932.582 1.353a28.79 28.79 0 0 1-1.426-.042c-1.856-.166-3.954-.036-4.785-2.107.59.238 1.17.649 2.917.774.512.035 1.512.008 2.713.022zM48.542 42.985c.131.461.317.899.555 1.304-2.793.013-18.345.092-30.702.085.243-.401.438-.835.576-1.294l14.036-.058s7.307-.016 15.536-.037h-.001z",
    fill: "#5F5F5F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.728 33.169s-2.765-.711-5.195-1c-4.55-.541-5.95-.423-5.95-.423-2.782-.06-4.616-.243-6.665-.237-1.128.004-28.496-1.117-31.48-1.117-1.992 0-5.15-.051-6.592.773-1.441.824 22.328.944 27.205 1.18 4.875.237 22.822.13 28.677.824z",
    fill: "#FAE3AF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.938 41.443c0 2.787 2.29 5.045 5.117 5.045 2.825 0 5.115-2.258 5.115-5.045s-2.291-5.046-5.115-5.046c-2.825 0-5.117 2.26-5.117 5.046z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.905 41.443c0 1.714 1.41 3.103 3.148 3.103 1.738 0 3.147-1.389 3.147-3.103 0-1.714-1.41-3.103-3.147-3.103-1.737 0-3.148 1.39-3.148 3.103z",
    fill: "#808184"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.37 41.443c0 2.787 2.29 5.045 5.115 5.045 2.824 0 5.118-2.258 5.118-5.045s-2.292-5.046-5.118-5.046c-2.826 0-5.115 2.26-5.115 5.046z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.339 41.443c0 1.714 1.41 3.103 3.146 3.103 1.737 0 3.148-1.389 3.148-3.103 0-1.714-1.409-3.103-3.148-3.103-1.74 0-3.146 1.39-3.146 3.103z",
    fill: "#808184"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.58 36.398s-1.694-1.526-4.44-1.526c-2.747 0-4.626 1.526-4.626 1.526s1.292-2.538 4.4-2.538c3.108 0 4.665 2.538 4.665 2.538h.001zM18.012 36.398s-1.693-1.526-4.441-1.526c-2.748 0-4.624 1.526-4.624 1.526s1.293-2.538 4.4-2.538 4.665 2.538 4.665 2.538z",
    fill: "#FAE3AF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.521 23.684c1.066-.043 5.325-.024 9.184.477 1.053.136 1.575 1.084 2.66 2.182 1.27 1.288 3.054 3.809 3.483 4.438.188.21-.04.384-.274.384l-14.254-.407c-.214-.028-.257-.147-.286-.245 0-.002-.004.066-.006.065l-.454-4.984-.192-1.693c-.014-.09-.023-.217.14-.217zM12.397 28.727c.184-.593 1.79-2.097 3.092-2.861 2.174-1.277 5.45-2.42 10.364-2.183.104 0 .155.086.155.196v6.393c0 .137-.086.312-.319.312l-10.577-.504s-3.026-.352-2.715-1.353zM41.726 24.163c.016-.043.071-.077.154-.107 1.05.527 2.843 1.626 4.446 2.744 1.293.902 3.912 3.114 5.499 3.873.142.067.285.128.432.183-1.226.068-4.303.236-4.617.242-.25.003-.38-.058-.526-.23-.078-.092-2.397-2.619-3.719-4.176-.8-.944-1.417-1.558-1.705-1.988-.124-.187.015-.487.037-.542l-.001.001z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-car.8559718feb18f711303e25fea37e4e5b.svg";